import React, { Component , useState} from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withRouter} from 'react-router-dom';
import { Container } from '@material-ui/core';
import firebase from "firebase/app";
import 'firebase/firestore';
import {authConfig} from '../auth/config';
import CardVeiculo from './cardVeiculo';

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
     
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      marginTop: theme.spacing(20),
    },
    submit: {
      margin: theme.spacing(2, 2, 2),
  
     
  
    },
}));

document.title = 'Frota UFSM'
document.logo=''

var listaveiculos=[];
var codunidadetransporte='';


export const  Veiculos = () => {
  const [campi,setacampi]=React.useState('');
  const [state, setState] = useState([]);
  var utipo='';
  

  React.useEffect(() => {
    
    listaveiculos=[];

    async function pegauser() {
      const user = authConfig.auth().currentUser;
       var db = firebase.firestore();
       var userref =  db.collection("usuarios").doc(user.uid);         
       console.log("esta aqui 001");
      await userref.get().then((doc) => {       
         if (doc.exists) {
           console.log("Document data pegouppqpq:", doc.data());
           utipo = doc.data().usertipo;
           codunidadetransporte = doc.data().codunidadetransporte;
           var campis=doc.data().campi;
           setacampi(campis);
           
            //console.log('porraaaaa' , doc.data().lotacao);
            pegalista();
         }else{
           alert('Não encontramos o seu cadastro')
         }
        
        }).catch(function(error) {
          alert("Erro ao localizar o seu cadastro ", error.message);
          })
    };

    async function pegalista() {          
      
      if((utipo==6)||(utipo==7)) {
       console.log("user tipo poxa"+ codunidadetransporte + "puta merda");
       var db = firebase.firestore();
       var query = await db.collection("veiculos").where("codunidadetransporte","==", codunidadetransporte).
       orderBy("placa").get()
       .then(function(querySnapshot) {
        console.log("entrou na porra do doc pega unidade motoras");
        querySnapshot.forEach(function(doc) {
          var listaveiculos1=[];
            listaveiculos1.push({id: doc.id, modelo: doc.data().modelo,
              placa:doc.data().placa, anofab: doc.data().ano, km: doc.data().km,
            marca: doc.data().marca, codunidadetransporte: doc.data().codunidadetransporte, status: doc.data().status,
            codtipoveiculo: doc.data().codtipoveiculo ,npassageiros: doc.data().npassageiros, capcarga: doc.data().capacidadecarga});
          console.log("veiculos pqp ", state );
         setState (currentArray => [...currentArray, listaveiculos1]);
         

        });
       
      })
     .catch(error => {
         console.log('Não encontramos motoristas cadastrados', error);
         alert("'Não encontramos Veículos cadastrados'");
     });
     
     }else {
      
     
      await firebase.firestore().collection("veiculos").get()
      .then(function(querySnapshot) {
        
        querySnapshot.forEach(function(doc) {
          var listaveiculos1=[];
            listaveiculos1.push({id: doc.id, modelo: doc.data().modelo,
              placa:doc.data().placa, anofab: doc.data().ano, km: doc.data().km, campi:campi,
            marca: doc.data().marca, codunidadetransporte: doc.data().codunidadetransporte, status: doc.data().status,
          codtipoveiculo: doc.data().codtipoveiculo ,npassageiros: doc.data().npassageiros, capcarga: doc.data().capacidadecarga});
          
          setState (array=>[...array,listaveiculos1]);
         

        })
        
        
       
      })
     .catch(error => {
         console.log('Não encontramos motoristas cadastrados', error);
         alert("'Não encontramos Veiculos cadastrados'");
     });
     
      
     }

     
}
    
    pegauser()
    
  
  
  console.log('agora sim é o tamanho ', campi);
  }, [0]); 
 
  const handlecadastar= ()=>{

       
                  var listaveiculos1=[];
                  listaveiculos1.push({id: false, modelo: '',
                    placa:'', anofab: '', km: '',codtipoveiculo:'',
                  marca: '', codunidadetransporte: codunidadetransporte, status: true, campi:campi,
                codtipoveiculo: '' ,npassageiros: '', capcarga: '', novo:true});
                console.log('props item vei item novo= ' ,listaveiculos1);
               setState (currentArray => [...currentArray,listaveiculos1]);


              /* setState(currentArray => (
                [listaveiculos1, ...currentArray]
              ))*/
   }

return(
 
<Container >
<CssBaseline />
      
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Veículos
          </Typography>
          <Container maxWidth="xs">
          <Grid container maxWidth="xs">
            <Grid item xs={6} >
            <Button
                onClick={handlecadastar}
                variant="contained"
                  color="primary"
                  className={classes.submit}
                  >
                  Cadastrar
                </Button>
            </Grid>
          </Grid>
                </Container>
            
      <div id="corpo"   align="center" className={classes.paper} >

      

           
           <Container maxWidth="xs">
             <Grid container spacing={1}>
            {console.log("valor do campi ants dcard ", campi)}
              {console.log('tamanho da lista=> ', state)}
             {state.map(item=>(
              <Grid item key={item.id } xs={12} >
                <CardVeiculo campi={campi} codtipov={item.codtipoveiculo} props={item} value={item.id} />
                </Grid>
               //console.log('tamanho da lista11111=> ', item)
               
             ))}
             </Grid>

             </Container>
           
          
          
      </div>
       
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)

}


 
export default Veiculos;
